import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { DatePipe, formatDate, formatNumber } from '@angular/common';
import { Title } from "@angular/platform-browser";
import { of, tap, Subscription, Subject, Observable, filter, throwError, EMPTY } from 'rxjs';
import { map, switchMap, catchError, retry, timeout, defaultIfEmpty } from 'rxjs/operators';
import { MenuItem, MessageService, FilterService } from 'primeng/api';



import { environment } from 'src/environments/environment';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { GraphData, DailyGraphData } from 'src/app/shared/dashboard';
import { RestApiService } from 'src/app/services/rest-api.service';

/*
 * pi-chart-bar
 * pi-chart-line
 * pi-calendar-times
 * pi-calendar
 * pi-calendar-minus
 */

@Component({
  selector: 'app-home-chart-daily-payments',
  templateUrl: './home-chart-daily-payments.component.html',
  styleUrl: './home-chart-daily-payments.component.css',
  encapsulation: ViewEncapsulation.None
})
export class HomeChartDailyPaymentsComponent implements OnInit, OnDestroy, OnChanges {

  today: Date = null;
  loading: boolean = true;

  globalSettinsData: GlobalSettingsData = null;

  dailyPayments: DailyGraphData[] = [];
  dataDailyPayments: GraphData = null;

  dayPerformanceToSee: number = 45;

  dailyGraphOptions: any = null;

  optionsDailyPayments = null;

  @Input() dayPaymentsToSee: number = 5;              // Days to see in daily payments graph

  @Output() onPeriodChange = new Subject<number>();   // Days to see change emitter (since today)

  dailyPaymentsQuery: Subscription = null;

  dayOptions: any = [
    { id: 1, name: 'Результат за 5 дней', days: '5' },
    { id: 2, name: 'Результат c начала недели', days: '15' },
    { id: 3, name: 'Результат за 10 дней', days: '10' },
    { id: 4, name: 'Результат c начала месяца', days: '30' },
    { id: 5, name: 'Результат за 30 дней', days: '30' },
  ];

  selectedOption: any = this.dayOptions[0];

  private getUserFriendlyError(operation: string, error: any): string {
    const errorMap: { [key: string]: string } = {
      'calculateDocItemsFields': 'Не вдалося завантажити дані документа',
      'saveDocItem': 'Не вдалося зберегти позицію',
      'deleteDocItem': 'Не вдалося видалити позицію',
      'loadProduct': 'Не вдалося завантажити дані товару',
      'calculateProfit': 'Помилка розрахунку прибутку',
      'exportData': 'Помилка експорту даних'
    };

    const message = errorMap[operation] || 'Невідома помилка';

    if (error.status === 0) {
      return `${message}: Немає з'єднання з сервером`;
    }
    if (error.status === 401) {
      return `${message}: Немає авторизації`;
    }
    if (error.status === 403) {
      return `${message}: Немає прав доступу`;
    }
    if (error.status === 404) {
      return `${message}: Дані не знайдено`;
    }
    if (error.status >= 500) {
      return `${message}: Помилка сервера`;
    }

    return message;
  }

  // Centralized error handler
  private handleError<T>(operation: string, result?: T) {
    return (error: any): Observable<T> => {

      console.error(`${operation} failed:`, error);

      // Log to monitoring service (if available)
      // this.errorLoggingService.logError(error);

      this.messageService.add({
        severity: 'error',
        summary: 'Помилка операції',
        detail: this.getUserFriendlyError(operation, error),
        life: 5000
      });

      // Stop loading indicators
      this.loading = false;

      // Return safe fallback
      return result ? of(result) : EMPTY;
    };
  }

  constructor(
    private restapi: RestApiService,
    private titleService: Title,
    private messageService: MessageService,
    private globalsettingsservice: GetglobalsettingsService,
  ) {

    this.onPeriodChange.pipe(
      filter(period => period > 0),
      filter(() => this.globalSettinsData != null),
      tap(() => environment.production || console.log('*** HomeChartDailyPaymentsComponent globalSettinsData: ' + JSON.stringify(this.globalSettinsData))),
      tap(() => this.loading = true),

      switchMap(period => this.restapi.getDailyPaymentsGraphData(this.globalSettinsData.mainCompanyId, this.today, period, 1, this.globalSettinsData.balanceCurrencyId, 0).pipe(
        timeout(10000),
        retry(1),

        map(data => this.dailyPayments = data),
        tap(data => environment.production || console.log('*** HomeChartDailyPaymentsComponent in onPeriodChange switchMap: ' + JSON.stringify(data))),
        tap(data => environment.production || console.table(data)),

        catchError(this.handleError('getDailyPaymentsGraphData', [])),
      )),

    ).subscribe(
      () => {
        if (this.dailyPayments) {
          this.dataDailyPayments = {
            labels: [],
            datasets: [
              {
                order: 1,
                label: 'Нарастающим итогом',
                data: [],
                type: 'line',
                tension: .4,
                fill: false,
                borderColor: '#277622',
                backgroundColor: 'white',
                yAxisID: 'yaxis2'
              },

              {
                order: 2,
                label: 'Среднее',
                data: [],
                type: 'line',
                fill: false,
                borderColor: '#111111',
                backgroundColor: '#277622',
                tension: .4,
                yAxisID: 'yaxis1'
              },

              {
                order: 3,
                label: 'Оплаты',
                data: [],
                fill: false,
                backgroundColor: '#379E2F',
                yAxisID: 'yaxis1'
              },

            ],
            options: {
            }
          }

          this.dailyPayments.forEach((element, index) => {

            this.dataDailyPayments.labels.push(formatDate(element.GRAFDATE, 'dd/MM/yyyy', 'uk'/*, 'GMT+2'*/));

            let daily = this.dataDailyPayments.datasets.find(ds => ds.label === 'Оплаты');
            if(daily) daily.data.push(element.GRAFVALUE);
            let median = this.dataDailyPayments.datasets.find(ds => ds.label === 'Среднее');
            if(median) median.data.push(element.MEDIUMVAL);
            let accumulated = this.dataDailyPayments.datasets.find(ds => ds.label === 'Нарастающим итогом');
            if(accumulated) accumulated.data.push(element.ACCUMULATED);
          });
        }
        this.loading = false;
      });
  }

  // Trigger data update on button click
  updateData() {
    this.onPeriodChange.next(this.dayPaymentsToSee);
  }

  onDayOptionsClick(event) {
    console.log('*** HomeChartDailyPaymentsComponent in onDayOptionsClick: ' + JSON.stringify(event));
    environment.production || console.log('*** HomeChartDailyPaymentsComponent in onDayOptionsClick: ' + JSON.stringify(this.selectedOption));

    if (this.selectedOption) {

      switch (this.selectedOption.id) {

        default:
          this.dayPaymentsToSee = this.selectedOption.days;
          break;

        case 2: {
          const today = new Date();
          const firstDayOfWeek = new Date(today);
          firstDayOfWeek.setDate(today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1));
          this.dayPaymentsToSee = Math.ceil((today.getTime() - firstDayOfWeek.getTime()) / (1000 * 60 * 60 * 24)) + 1;
        }
          break;

        case 4: {
          const today = new Date();
          const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
          this.dayPaymentsToSee = Math.ceil((today.getTime() - firstDayOfMonth.getTime()) / (1000 * 60 * 60 * 24));
        }
          break;
      }
    }
    this.onPeriodChange.next(this.dayPaymentsToSee);
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** HomeChartDailyPaymentsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** HomeChartDailyPaymentsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'dayPaymentsToSee':
          this.onPeriodChange.next(change.currentValue);
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** HomeChartDailyPaymentsComponent ngOnDestroy")

    if(this.dailyPaymentsQuery) { this.dailyPaymentsQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    this.today = new Date();

    console.log('*** HomeChartDailyPaymentsComponent in onInit: ' + JSON.stringify(this.today));

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.dailyGraphOptions = {
      scales: {
        yaxis1: {
          axisID: 'y-axis-1',
          type: 'linear',
          display: 'auto',
          position: 'left',
          scaleBeginAtZero: true,
          ticks: {
            color: textColorSecondary,
            beginAtZero: true,
            min: 0
          },
          grid: {
            display: true,
            color: surfaceBorder
          }
        },
        yaxis2: {
          axisID: 'y-axis-2',
          type: 'linear',
          display: 'auto',
          position: 'right',
          scaleBeginAtZero: true,
          ticks: {
            color: textColorSecondary,
            beginAtZero: true,
            min: 0
          },
          grid: {
            display:  false,
            color: surfaceBorder
          }
        },
      },
      tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
          label: function (tooltipItems, data) {
            environment.production || console.log('tooltips item: ' + JSON.stringify(tooltipItems));
            return '$' + formatNumber(<number>tooltipItems.yLabel, 'uk', '1.0-0');
          }
        }
      },
    };

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();
    this.titleService.setTitle('Платежи - ежедневный график с усреднением и накоплением');

    this.onPeriodChange.next(this.dayPaymentsToSee);
  }

  selectData(event) {
  }
}
